
/* injects from baggage-loader */

'use strict';

export default class NorthCapitalCheckMailingInstructionsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
